import {MAX_DOCUMENT_BYTES,ScriptDocument} from '@estudio/contracts';
import {newBlockId} from './blocks.ts';

/** Plain text only, without editor markup or voice-effect attributes. The source
 * receipt hashes this exact string, so never trim or collapse whitespace here.
 */
export function scriptToNotebookText(script:ScriptDocument):string{
  return script.blocks.map(block=>block.text).join('\n\n');
}

/** Inverse of the plain-text representation, preserving whitespace. Runtime
 * retries can supply a content-hash prefix to produce identical request bytes.
 */
export function notebookTextToScript(text:string,idPrefix?:string):ScriptDocument{
  if(!text.trim()||text.includes('\0'))throw new Error('La fuente no contiene texto válido.');
  if(idPrefix&&!/^[A-Za-z0-9_-]{4,48}$/.test(idPrefix))throw new Error('Referencia de importación inválida.');
  if(new TextEncoder().encode(text).length>MAX_DOCUMENT_BYTES)throw new Error('La fuente supera el límite del guion (512 KiB).');
  const parts=text.split('\n\n');
  if(parts.length>5000)throw new Error('La fuente tiene demasiados párrafos; divídela antes de importar.');
  const content=ScriptDocument.parse({schema_version:1,type:'doc',blocks:parts.map((text,index)=>({
    id:idPrefix?`${idPrefix}_${index}`:newBlockId(),type:'paragraph',text,
    node:{type:'paragraph',...(text?{content:[{type:'text',text}]}:{})},
  }))});
  if(new TextEncoder().encode(JSON.stringify(content)).length>MAX_DOCUMENT_BYTES)throw new Error('El guion convertido supera el límite de 512 KiB.');
  return content;
}
